import React from "react"
import { graphql } from "@apollo/client/react/hoc"
import TabbedListingPage from "../Material/TabbedListingPage"
import { HasPermissionsQuery } from "../Functions/querys"
import TPAListContainer from "./TPA/TPAListContainer"
import TPAConfigListContainer from "./TPAConfig/TPAConfigListContainer"
import TPAAdjustersListContainer from "./TPAAdjusters/TPAAdjustersListContainer"
import { ROUTES } from "../Layout/routes"

// All three panels self-supply location/navigate via their own withApolloClient
// wrap, so the only thing each actually reads off props is currentUser.
const tpaTabs = [
    { id: "tpa", name: "TPA", iconClassName: "fa fa-users", permissionRequired: "view_tpa", render: ({ currentUser }) => <TPAListContainer currentUser={currentUser} /> },
    { id: "configuration", name: "Configuration", iconClassName: "fa fa-cogs", permissionRequired: "view_tpaconfig", render: ({ currentUser }) => <TPAConfigListContainer currentUser={currentUser} /> },
    { id: "adjusters", name: "Adjusters", iconClassName: "fa fa-address-card", permissionRequired: "view_tpaadjuster", render: ({ currentUser }) => <TPAAdjustersListContainer currentUser={currentUser} /> },
]

const TPAPage = (props) => (
    <TabbedListingPage
        className="tpaPage"
        route={ROUTES.tpa}
        tabs={tpaTabs.map(tab => ({ ...tab, render: () => tab.render({ currentUser: props.currentUser }) }))}
        hasPermissions={props.hasPermissions}
        loading={props.loading}
    />
)

export { tpaTabs }

export default graphql(HasPermissionsQuery, {
    options: () => ({ variables: { userPermissions: ["view_tpa", "view_tpaconfig", "view_tpaadjuster"] } }),
    props: ({ data: { hasPermissions, loading } }) => ({ hasPermissions, loading }),
})(TPAPage)
